document.addEventListener('DOMContentLoaded', () => {

    let imagesSliders = document.querySelectorAll('.images-sliders');
    if(imagesSliders){
        imagesSliders.forEach((item)=>{
            new Swiper(item, {
                rewind: true,
                effect: "fade",
                fadeEffect: {
                    "crossFade": true
                },
                pagination: {
                    el: ".pagination-images",
                    clickable: true,
                },
                navigation: {
                    nextEl: ".sw-but-img-next",
                    prevEl: ".sw-but-img-prev",
                },
            });
        });
    }

    let swiperTop = document.querySelectorAll('.swiper-top');
    if(swiperTop){
        swiperTop.forEach((item)=>{
            new Swiper(item, {
                loop: true,
                effect: "fade",
                speed: 1000,
                fadeEffect: {
                    "crossFade": true
                },
                autoplay: {
                    delay: 80000,
                    disableOnInteraction: false,
                },
                navigation: {
                    nextEl: ".sw-but-next",
                    prevEl: ".sw-but-prev",
                },
                pagination: {
                    el: ".header-pagination",
                    clickable: true,
                }
            });
        });
    }

    let sliderHero = document.querySelectorAll('.slider-hero');
    let heroSliderBrand = document.getElementById('hero_slider_brand');
    let heroNavBrand = document.getElementById('hero_nav_brand');

    if(sliderHero){
        sliderHero.forEach((item)=>{
            sliderHero = new Swiper(item, {
                loop: true,
                effect: "fade",
                speed: 1000,
                fadeEffect: {
                    "crossFade": true
                },
                autoplay: {
                    delay: 80000,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: ".header-pagination",
                    clickable: true,
                }
            });
        });
    }

    if(heroNavBrand){
        let navItem = heroNavBrand.querySelectorAll('.nav-item');
        navItem.forEach(function(h_nav) {
            let navCount = h_nav.dataset.nav;
            h_nav.addEventListener('click', function(e){
                e.preventDefault();
                if(!heroSliderBrand.classList.contains('active')){
                    heroSliderBrand.classList.add('active');
                }
                sliderHero.slideTo(navCount, 1000);
                navItem.forEach(function(h_nav) {
                    h_nav.classList.remove('active');
                });
                this.classList.add('active');
            });
        });
        sliderHero.on('slideChange', function () {
            let navIn = 0;
            navItem.forEach(function(h_nav) {
                let navC = h_nav.dataset.nav;
                h_nav.classList.remove('active');
                if(sliderHero.realIndex == navC){
                    h_nav.classList.add('active');
                }
                navIn++;
            });
        });
    }

    let sliderSlide = document.querySelectorAll('.slide-slider');
    if(sliderSlide){
        sliderSlide.forEach((item)=> {
            new Swiper(item, {
                loop: true,
                effect: "fade",
                uniqueNavElements: false,
                autoHeight: true,
                fadeEffect: {
                    "crossFade": true
                },
                autoplay: {
                    delay: 8000,
                    disableOnInteraction: false,
                },
                navigation: {
                    nextEl: ".sw-but-next",
                    prevEl: ".sw-but-prev",
                },
                pagination: {
                    el: ".slider-pagination",
                    clickable: true
                },
                breakpoints: {
                    600: {
                        autoHeight: false,
                    }
                }
            });
        });
    }

    let sliderSlideD = document.querySelectorAll('.slide-d-slider');
    if(sliderSlideD){
        sliderSlideD.forEach((item)=> {
            new Swiper(item, {
                loop: true,
                effect: "fade",
                uniqueNavElements: false,
                autoHeight: true,
                fadeEffect: {
                    "crossFade": true
                },
                autoplay: {
                    delay: 8000,
                    disableOnInteraction: false,
                },
                navigation: {
                    nextEl: ".sw-but-next",
                    prevEl: ".sw-but-prev",
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true
                },
                breakpoints: {
                    600: {
                        autoHeight: false,
                    }
                }
            });
        });
    }

    let sliderOSlide = document.querySelectorAll('.slide-o-slider');
    if(sliderOSlide){
        sliderOSlide.forEach((item)=> {
            new Swiper(item, {
                loop: true,
                effect: "fade",
                uniqueNavElements: false,
                autoHeight: true,
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-but-next",
                    prevEl: ".sw-but-prev",
                },
                pagination: {
                    el: ".slider-o-pagination",
                    clickable: true
                },
                breakpoints: {
                    600: {
                        autoHeight: false,
                    }
                }
            });
        });
    }

    let reviewsSlides = document.querySelectorAll('.reviews-slides');
    if(reviewsSlides){
        reviewsSlides.forEach((item)=> {
            new Swiper(item, {
                loop: true,
                effect: "fade",
                uniqueNavElements: false,
                autoHeight: true,
                fadeEffect: {
                    "crossFade": true
                },
                pagination: {
                    el: ".pagination-reviews",
                    clickable: true,
                },
                navigation: {
                    nextEl: ".sw-but-next",
                    prevEl: ".sw-but-prev",
                },
                breakpoints: {
                    600: {
                        autoHeight: false,
                    }
                }
            });
        });
    }

    let gallerySlider = document.querySelectorAll('.gallery-slider');
    if(gallerySlider){
        gallerySlider.forEach((item)=> {
            new Swiper(item, {
                loop: false,
                effect: "fade",
                rewind: true,
                fadeEffect: {
                    "crossFade": true
                },
                pagination: {
                    el: ".gallery-pagination",
                    clickable: true
                }
            });
        });
    }

    let galleryGSlider = document.querySelectorAll('.gallery-grid-slider');
    if(galleryGSlider){
        galleryGSlider.forEach((item)=> {
            new Swiper(item, {
                loop: false,
                effect: "fade",
                rewind: true,
                fadeEffect: {
                    "crossFade": true
                },
                pagination: {
                    el: ".gallery-grid-pagination",
                    clickable: true
                },
                navigation: {
                    nextEl: ".sw-gal-next",
                    prevEl: ".sw-gal-prev",
                }
            });
        });
    }

    let galleryCarouselSlider = document.querySelectorAll('.gallery-carousel-slider');
    if(galleryCarouselSlider){
        galleryCarouselSlider.forEach((item)=> {
            new Swiper(item, {
                loop: true,
                slidesPerView: 'auto',
                uniqueNavElements: false,
                fadeEffect: {
                    "crossFade": true
                },
                pagination: {
                    el: ".gallery-carr-pagination",
                    clickable: true
                }
            });
        });
    }

    let galleryMSlider = document.querySelectorAll('.gallery-m-slider');
    if(galleryMSlider){
        galleryMSlider.forEach((item)=> {
            new Swiper(item, {
                loop: true,
                rewind: true,
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-gal-next",
                    prevEl: ".sw-gal-prev",
                }
            });
        });
    }

    let cardsSlider = document.querySelectorAll('.cards-slider');
    if(cardsSlider){
        cardsSlider.forEach((item)=> {
            new Swiper(item, {
                loop: false,
                autoHeight: true,
                fadeEffect: {
                    "crossFade": true
                },
                pagination: {
                    el: ".cards-pagination",
                    clickable: true
                },
                breakpoints: {
                    600: {
                        autoHeight: false,
                    }
                }
            });
        });
    }

    let eventsSlider = document.querySelectorAll('.events-slider');
    if(eventsSlider){
        eventsSlider.forEach((item)=> {
            new Swiper(item, {
                loop: false,
                slidesPerView: 1,
                spaceBetween: 0,
                rewind: true,
                autoHeight: true,
                uniqueNavElements: false,
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-eve-next",
                    prevEl: ".sw-eve-prev",
                },
                breakpoints: {
                    1025: {
                        slidesPerView: 3,
                        spaceBetween: 50,
                    },
                    600: {
                        slidesPerView: 2,
                        spaceBetween: 50,
                    }
                }
            });
        });
    }

    let sliderSlideSpecials = document.querySelectorAll('.slide-slider-specials');
    if(sliderSlideSpecials){
        sliderSlideSpecials.forEach((item) => {
            new Swiper(item, {
                loop: true,
                slidesPerView: 1,
                spaceBetween: 25,
                uniqueNavElements: false,
                autoHeight: true,
                autoplay: {
                    delay: 6000,
                    disableOnInteraction: false,
                },
                navigation: {
                    nextEl: ".sw-but-next",
                    prevEl: ".sw-but-prev",
                },
                pagination: {
                    el: ".slider-pagination",
                    clickable: true,
                },
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                        autoHeight: false,
                    },
                    1024: {
                        slidesPerView: 3,
                        autoHeight: false,
                    },
                },
            });
        });
    }

});